import { inject, Injectable } from '@angular/core';
import {
  HapticsService,
  SoundEffectsService,
  SuccessSound,
} from '@marineform/fe-util';
import { ToastController } from '@ionic/angular';

const DURATION = 2000;

export type AlertOptions = {
  duration?: number;
};

export type AlertSuccessOptions = AlertOptions & {
  sound?: SuccessSound;
};

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  #toastController = inject(ToastController);
  #haptics = inject(HapticsService);
  #sounds = inject(SoundEffectsService);

  async success(message: string, options: AlertSuccessOptions = {}) {
    const toast = await this.#toastController.create({
      message,
      duration: options.duration ?? DURATION,
      color: 'success',
      position: 'top',
      translucent: true,
      swipeGesture: 'vertical',
    });
    this.#haptics.lightImpact();
    this.#sounds.success(options.sound ?? 'medium');
    await toast.present();
  }

  async error(message: string, options: AlertOptions = {}) {
    const toast = await this.#toastController.create({
      message,
      duration: options.duration ?? DURATION,
      color: 'danger',
      position: 'top',
      translucent: true,
      swipeGesture: 'vertical',
    });
    this.#haptics.lightImpact();
    this.#sounds.error();
    await toast.present();
  }

  async info(message: string, options: AlertOptions = {}) {
    const toast = await this.#toastController.create({
      message,
      duration: options.duration ?? DURATION,
      position: 'top',
      translucent: true,
      swipeGesture: 'vertical',
      color: 'dark',
    });
    this.#haptics.lightImpact();
    await toast.present();
  }
}
